module.exports = __webpack_public_path__ + "static/media/hydraulics-icon.24dcd218.png";